import type { FieldLabelProps } from '@base-ui/react';
import type { ReactNode } from 'react';

import { Field as BaseField } from '@base-ui/react';
import { useTranslation } from 'react-i18next';

import { srOnlyStyle } from '~/styles/utilities.css';
import { clsxs } from '~/styles/utils';

import { Infotip } from '../../Infotip/Infotip';
import { fieldLabelStyle, optionalStyle } from './FieldLabel.css';

type Props = FieldLabelProps & {
  infotip?: ReactNode;
  optional?: boolean;
  srOnly?: boolean;
};

export const FieldLabel = ({ children, infotip, optional, srOnly = false, ...delegated }: Props) => {
  const { t } = useTranslation(['common']);

  return (
    <BaseField.Label {...delegated} className={clsxs(fieldLabelStyle, srOnly && srOnlyStyle, delegated.className)}>
      <span>{children}</span>
      {optional && <span className={optionalStyle}>{t('common:optionalInput')}</span>}
      {infotip && <Infotip>{infotip}</Infotip>}
    </BaseField.Label>
  );
};
